import React, { useContext } from 'react';
import DuoSubLandingPage from 'components/SubLandingPage/Duo';
import { buildUrlStrict } from 'lib/url';
import { useTranslation } from 'data/translation/useTranslation';
import { TrackingContext } from 'data/tracking/context';
import {
  joinLandingPageAuth,
  joinLandingPageNonAuth,
} from 'lib/trackingEvents';
import { usePageViewFromContext } from 'data/tracking/usePageView';

type DuoSubLandingPageContainerProps = {
  inviteToken: string;
  authenticated: boolean;
  legalTermsUrl: string;
  mastheadData: any;
};
export function DuoSubLandingPageContainer({
  inviteToken,
  authenticated,
  legalTermsUrl,
  mastheadData,
}: DuoSubLandingPageContainerProps) {
  const { locale } = useTranslation();
  const { trackEvent } = useContext(TrackingContext);
  const event = authenticated ? joinLandingPageAuth : joinLandingPageNonAuth;

  usePageViewFromContext(event.pageView);

  return (
    <DuoSubLandingPage
      joinUrl={buildUrlStrict('duo', 'SUB_CONFIRM_ACCOUNT', locale, {
        token: inviteToken!,
      })}
      onJoinClick={() => trackEvent(event.join)}
      termsUrl={legalTermsUrl}
      onTermsClick={() => trackEvent(event.toc)}
      mastheadData={mastheadData}
    />
  );
}
